// Shared filter vocabulary for the manufacturer reports (the on-screen tables,
// their CSV/xlsx exports and the reconciliation report attached to billing
// invoices).
//
// Cancelled orders are never billable, so they are not offered as a filter
// option at all — the API refuses them too. The remaining statuses can be
// narrowed; leaving the selection empty means "all of them".

// Manufacturer reports bill only orders placed with the Origins Direct
// supplier. Wholesaler / indirect orders are never part of that bill, so the
// report no longer offers a system switcher. Origins Direct Instant is still
// included — it is the same supplier.
export const MANUFACTURER_REPORT_SCOPE =
  'Origins Direct orders only. Wholesaler orders are not included.'

// The order statuses a manufacturer report can include.
export const ORDER_STATUS_OPTIONS = [
  { name: 'Pending', value: 'Pending' },
  { name: 'Confirmed', value: 'Confirmed' },
  { name: 'Received', value: 'Received' },
]

// Statuses no manufacturer report ever counts, with the reason shown in the UI.
export const ALWAYS_EXCLUDED_STATUSES = [
  {
    status: 'Cancelled',
    reason: 'Cancelled orders are never billable, so they are always left out.',
  },
]

// Builds the query string shared by every manufacturer report request. Omits
// anything that is not set, so an unfiltered report is still a bare URL.
export const buildReportParams = ({
  startDate,
  endDate,
  statuses,
  formatDate,
  extra = {},
} = {}) => {
  const parts = []

  Object.entries(extra).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      parts.push(`${key}=${encodeURIComponent(value)}`)
    }
  })

  if (startDate) parts.push(`startDate=${formatDate(startDate)}`)
  if (endDate) parts.push(`endDate=${formatDate(endDate)}`)
  if (statuses && statuses.length > 0) {
    statuses.forEach((status) =>
      parts.push(`status=${encodeURIComponent(status)}`)
    )
  }

  return parts.length > 0 ? `?${parts.join('&')}` : ''
}
